var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy273(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "podklad"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M89.6,4c3.1,0,5.6,2.5,5.6,5.6v80c0,3.1-2.5,5.6-5.6,5.6h-80c-3.1,0-5.6-2.5-5.6-5.6v-80C4,6.5,6.5,4,9.6,4 H89.6 M89.6,0h-80C4.3,0,0,4.3,0,9.6v80c0,5.3,4.3,9.6,9.6,9.6h80c5.3,0,9.6-4.3,9.6-9.6v-80C99.2,4.3,94.9,0,89.6,0L89.6,0z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg5673"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M83.9,33.7c-1.8-5.1-6-8.4-10.2-10.4c-2.4-1.1-7.6-2.1-10.1-2.8c-1.5-0.4-8.8-1.3-10.3-1.3 c-0.9,0-2.8,0-3.7,0c-0.9,0-2.8,0-3.7,0c-1.5,0-8.8,0.9-10.3,1.3c-2.5,0.7-7.8,1.7-10.1,2.8c-4.7,2.3-8.3,5.3-10.2,10.4 c-1.1,3.2-1.3,6.6-0.4,9.8L19,63c1.3,5,4.9,9.1,9.7,11.1l8.4,3.5c1.3,0.5,2.6,0.9,4,1.1l0.2-2.7c0.1-1.4,1.3-2.5,2.8-2.5h5.5h5.5 c1.5,0,2.7,1.1,2.8,2.5l0.2,2.7c1.4-0.2,2.7-0.6,4-1.1l8.4-3.5c4.8-2,8.4-6.1,9.7-11.1l4.1-19.5C85.2,40.3,85,36.8,83.9,33.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 30.5,
    cy: 38,
    r: 10.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 30.5,
    cy: 38,
    r: 4.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 68.7,
    cy: 38,
    r: 10.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 68.7,
    cy: 38,
    r: 4.4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 49.6,
    cy: 65.8,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 65.4,
    cy: 67.1,
    r: 4.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 33.8,
    cy: 67.1,
    r: 4.4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy273);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-273.465aaab01e9782e3ee2e1f138649343e.svg";
export { ForwardRef as ReactComponent };